import React, { useMemo } from 'react';
import { SignIn } from '@clerk/clerk-react';
import { useLocation } from 'react-router-dom';

function SignInPage() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirectUrl = searchParams.get('redirectUrl') || '/'; // fallback

  const redirectTo = useMemo(() => redirectUrl, [redirectUrl]);

  return (
    <div className="justify-center flex items-center py-32 min-h-screen bg-gray-900">
      <SignIn redirectUrl={redirectTo} />
    </div>
  );
}

export default SignInPage;
